import { NSARouterMakerResult } from "namirasoft-account-react";
import { InvoiceRow, SubscriptionRow, SubscriptionValidation } from "namirasoft-payment";
import { NSMenuActionProps } from "namirasoft-site-react";
import { PaymentRoutes } from "./PaymentRoutes";

export class PaymentMenus
{
	static CancelSubscription(props: NSARouterMakerResult, getIDs: () => string[], getRows: () => SubscriptionRow[]): NSMenuActionProps
	{
		return {
			id: "1",
			menu_item: "Cancel Subscription",
			isActive: () =>
			{
				if (getIDs().length === 1)
				{
					let subscription = getRows()[0];
					if (subscription)
						return SubscriptionValidation.isValidStatus(subscription.status);
				}
				return false;
			},
			onClick: {
				action: () =>
				{
					let ids = getIDs();
					if (ids.length === 1)
						props.url.redirect(PaymentRoutes.SubscriptionCancellation(ids[0], true, ""), {});
				},
				showLoading: false
			}
		}
	}
	static PayInvoice(props: NSARouterMakerResult, getIDs: () => string[], getRows: () => InvoiceRow[]): NSMenuActionProps
	{
		return {
			id: "2",
			menu_item: "Pay",
			isActive: () =>
			{
				if (getIDs().length === 1)
				{
					let invoice = getRows()[0];
					if (invoice)
						return invoice.total_balance > 0;
				}
				return false;
			},
			onClick: {
				action: () =>
				{
					let ids = getIDs();
					if (ids.length > 0)
						props.url.redirect(PaymentRoutes.InvoiceGateway(ids[0], true, ""), []);
				},
				showLoading: false
			}
		}
	}
}